<template>
  <span>
    <span>{{ $t('home.orderLineStatusSummary') }}</span>
    <div>
      <el-select
        v-model="selectedDomainID"
        class="search-select"
        type="select"
        style="margin-bottom: 10px;margin-top:10px"
        :placeholder="$t('common.domain')"
        @change="handleDomainChange"
      >
        <el-option v-for="domain in domains" :key="domain.id" :label="domain.name" :value="domain.id" />
      </el-select>
      <el-date-picker
        v-model="selectedWeek"
        type="week"
        format="WW"
        value-format="yyyy-MM-dd"
        :clearable="false"
        :placeholder="$t('common.week')"
        style="margin-bottom: 10px; margin-left: 10px"
        @change="handleWeekChange"
      />
      <el-select
        v-model="selectedProductGroupID"
        class="search-select"
        type="select"
        style="margin-bottom: 10px; margin-left: 10px"
        :placeholder="$t('common.productGroup')"
        :clearable="true"
        @change="handleProductGroupChange"
      >
        <el-option
          v-for="productGroup in productGroups"
          :key="productGroup.id"
          :label="productGroup.description"
          :value="productGroup.id"
        />
      </el-select>
      <el-select
        v-model="selectedWorkshopID"
        class="search-select"
        type="select"
        style="margin-bottom: 10px; margin-left: 10px"
        :placeholder="$t('common.workshop')"
        :clearable="true"
        @change="handleWorkshopChange"
      >
        <el-option v-for="workshop in workshops" :key="workshop.id" :label="workshop.name" :value="workshop.id" />
      </el-select>
    </div>
    <div>
      <el-table :data="loadedData.counts" fit>
        <el-table-column width="100px">
          <template slot-scope="scope">
            <span>{{ formatOrderLineStatus(scope.row['status']) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="150px">
          <template slot-scope="scope">
            <span>{{ scope.row['substatus'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('orderLineStatusSummary.total')" width="65px" align="right">
          <template slot-scope="scope">
            <span>{{ scope.row['total'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.fri') + formatDate(loadedData.previousFriday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['previousFriday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.sat') + formatDate(loadedData.saturday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['saturday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.sun') + formatDate(loadedData.sunday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['sunday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.mon') + formatDate(loadedData.monday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['monday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.tue') + formatDate(loadedData.tuesday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['tuesday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.wed') + formatDate(loadedData.wednesday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['wednesday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.thu') + formatDate(loadedData.thursday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['thursday'] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orderLineStatusSummary.fri') + formatDate(loadedData.friday)"
          width="65px"
          align="right"
        >
          <template slot-scope="scope">
            <span>{{ scope.row['friday'] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </span>
</template>

<script>
export default {
  name: 'OrderLineStatusSummary',
  data() {
    return {
      loadedData: [],
      selectedDomainID: null,
      selectedProductGroupID: null,
      selectedWeek: null,
      selectedWorkshopID: null
    };
  },
  computed: {
    domains() {
      return this.$store.getters.domains;
    },
    productGroups() {
      return this.$store.getters['productGroup/loadedItems'];
    },
    workshops() {
      return this.$store.getters.workshops;
    }
  },
  created() {
    this.$store.dispatch('productGroup/getItems');
  },
  methods: {
    formatDate(value) {
      if (value) {
        const date = new Date(value);
        return ` ${date.getDate()}/${date.getMonth() + 1}`; // getMonth starts at 0.
      }
      return '';
    },
    formatOrderLineStatus(cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('orderLineStatus').find(item => item.code === cellValue);
      return option && option.description;
    },
    getSummary() {
      if (this.selectedDomainID == null || this.selectedWeek == null) {
        return null;
      }
      this.$store
        .dispatch('orderLineStatus/getSummary', {
          domainID: this.selectedDomainID,
          someMonday: this.selectedWeek,
          productGroupID: this.selectedProductGroupID,
          workshopID: this.selectedWorkshopID
        })
        .then(data => {
          if (data && data.counts) {
            this.loadedData = data;
          }
        });
    },
    handleDomainChange() {
      this.getSummary();
    },
    handleProductGroupChange() {
      this.getSummary();
    },
    handleWeekChange() {
      this.getSummary();
    },
    handleWorkshopChange() {
      this.getSummary();
    }
  }
};
</script>
